import React from "react";
import { graphql } from "gatsby";
import TermsTemplate from "@components/termsPage/termsTemplate";

const IndexPage = ({
  data: {
    prismic: {
      allTermss: {
        edges: {
          0: { node: termsData },
        },
      },
    },
  },
  pageContext,
}) => <TermsTemplate data={termsData} pageContext={pageContext} />;

export const query = graphql`
  query AllTermss($localeCode: String) {
    prismic {
      allTermss(lang: $localeCode) {
        edges {
          node {
            termsHeroHeading
            termsHeroSubheading
            termsHeroImage
            cookiesText
            cookiesTitle
            dataPolicyText
            dataPolicyTitle
            partnersText
            partnersTitle
            privacyPolicyText
            privacyPolicyTitle
            referralProgrammeText
            referralProgrammeTitle
            refundPolicyText
            refundPolicyTitle
            termsOfServiceText
            termsOfServiceTitle
            reportingChannelText
            reportingChannelTitle
          }
        }
      }
    }
  }
`;

export default IndexPage;
